$(document).ready(function () {
  var EVENT_RE = /\/([^\/]+)\/([^\/]+)\/booking/;
  var EVENT_NAME = undefined;
  var isLounge = document.location.pathname.indexOf("/" + site + "/lounge") > -1;
  var isLoungeHome = document.location.pathname === "/" + site + "/lounge";
  var isCamp = document.location.pathname.indexOf("booking-camp") > -1;
  var isLocationEvent = false;

  if (document.location.pathname.indexOf("/ottawa/sens") > -1) {
    isLoungeHome = true;
    isLounge = true;
  }

  if (isCamp) return;

  var VENUE_TZ = "America/New_York";
  if (site === "brisbane") {
    VENUE_TZ = "Australia/Brisbane";
  } else if (site === "regina" || site === "saskatoon") {
    VENUE_TZ = "America/Regina";
  }

  var PAGE_BASE = KIOSK_MODE ? kioskPath : "/" + site;
  if (isLounge) {
    PAGE_BASE = "/" + site + "/lounge";
  } else if (!KIOSK_MODE && EVENT_RE.test(document.location.pathname)) {
    var matches = document.location.pathname.match(EVENT_RE);
    EVENT_NAME = matches[2];
    isLocationEvent = true;
    PAGE_BASE = "/" + site + "/" + EVENT_NAME;
    $(".section-filters").hide();
  }
  var PAGE_CALENDAR = PAGE_BASE + "/booking";
  var PAGE_BOOK = PAGE_BASE + "/booking-book";
  var PAGE_COMPLETE = PAGE_BASE + "/booking-complete";

  var browserTZ = moment.tz.guess();
  var today = moment().tz(VENUE_TZ);
  if (KIOSK_MODE === true) {
    today.add(1, "days");
  }
  var NOW = today.clone().add(15, "minutes"); // add 15 minutes so we can't book last minute
  var SIX_MONTHS = today.clone().add(7, "months").endOf("month");
  var START_SEARCH_DATE = today.clone();
  if (START_SEARCH_DATE.hour() <= 1) {
    START_SEARCH_DATE.add(-1, "day");
  }

  var DATES_PER_FETCH = site === "ottawa" ? 2 : 5;
  var DEVELOPMENT = document.location.host.indexOf("dev.") !== -1 ? true : false;
  var ENABLE_PUSHSTATE = true;
  var SCROLL_ENABLED = !isLoungeHome && !isLocationEvent;
  if (isLoungeHome) {
    DATES_PER_FETCH = 6;
  }

  // default booking state
  var DEFAULT_STATE = {
    action: "calendar",
    date: START_SEARCH_DATE.format("YYYYMMDD"),
    start: START_SEARCH_DATE.format("YYYYMMDD"),
    event: null,
    venue: null,
    time: null,
    players: null,
  };

  // init state
  var state = $.extend(true, {}, DEFAULT_STATE);
  window.emState = state;

  var allDates = {};
  var lastDateFetched = null;
  var isLoading = false;
  var isAutoScroll = false;
  var bookingProcessing = false;
  var lastUpdateCalendarPromise = null;
  var finishedLoading = false;

  // copy html elements so we can generate time slots on the fly
  var $window = $(window);
  var $document = $(document);
  var footerHeight = $(".footer").height() || 0;
  var $bookings = $(".booking-dates");
  var $loadingCopy = $(".booking-loading").clone();
  var $bookingCopy = $(".booking-container").clone().removeClass("booking-container").show();
  var $eventCopy = $bookingCopy.find(".booking-event").clone();
  $bookingCopy.find(".booking-event").remove();
  var $slotCopy = $eventCopy.find(".booking-slot").first().clone();
  var _spinner = null;

  // history back
  if (ENABLE_PUSHSTATE) {
    $(window).bind("popstate", function change(e) {
      if (finishedLoading === false) {
        return;
      }
      if (e.originalEvent.state !== null) {
        if (DEVELOPMENT) {
          console.log("Pop: " + JSON.stringify(state));
        }
        if (e.originalEvent && e.originalEvent.state) {
          if (e.originalEvent.state.action === "book") {
            state = e.originalEvent.state;
            return showBook({ skipUpdateUrl: true });
          } else if (e.originalEvent.state.action === "calendar") {
            e.originalEvent.state.start = state.date;
            state = e.originalEvent.state;
            return showCalendar({ clear: true, useCache: true });
          }
        }
      }

      // reset state
      state = $.extend(true, {}, DEFAULT_STATE);
      return showCalendar();
    });
  }

  // add history
  function updateUrl(url, replace, func) {
    var promise = $.Deferred();

    promise.then(function () {
      url += queryFromState(state);
      if (DEVELOPMENT) {
        console.log("Push: " + JSON.stringify(state));
      }
      if (ENABLE_PUSHSTATE && history.pushState) {
        var title = "Booking Calendar | Escape Manor";
        if (state.action === "book") {
          var slot = getSelectedTimeSlot();
          title = slot.event.reservation.name + " " + formatDate(state.date) + " " + formatTime(state.time) + " | Escape Manor";
        }
        if (replace) {
          history.replaceState(state, title, url);
        } else {
          history.pushState(state, title, url);
        }
        document.title = title;
      } else {
        window.location = url;
      }
    });

    if (typeof func === "function") {
      func.apply(this, [promise]);
    } else {
      promise.resolve();
    }
    return promise.promise();
  }

  /**
   * On finished loading
   */
  function onFinishedLoading() {
    addSpinner({ clear: true });

    var _state = stateFromQuery();
    $.each(Object.keys(_state), function (index, key) {
      state[key] = _state[key];
    });
    if (DEVELOPMENT) {
      console.log("State From Query: " + JSON.stringify(state));
    }

    if (Object.keys(state).length > 0) {
      // prevent book page from reloading
      if (state.action === "complete") {
        window.location = PAGE_CALENDAR;
        return;
      }
    }

    /**
     * Check for bsource field.
     */
    if (state["bsource"]) {
      var bsource = state["bsource"];
      delete state["bsource"];
      var url = PAGE_CALENDAR + queryFromState(state);

      // replace state to avoid duplicate bsource tracking hits
      if (ENABLE_PUSHSTATE && history.pushState) {
        history.replaceState(state, document.title, url);
      } else {
        setTimeout(function () {
          window.location = url;
        }, 250);
        return; // stop page load
      }
    }

    if (state.action === "calendar") {
      finishedLoading = true;
      updateCalendar();
    } else if (state.action === "book") {
      state.start = state.date;
      state.end = moment.tz(state.start, "YYYYMMDD", VENUE_TZ).add(DATES_PER_FETCH, "days").format("YYYYMMDD");
      getBookings(state)
        .done(function () {
          showBook({ refreshHtmlOnly: false, skipUpdateUrl: true });
          finishedLoading = true;
        })
        .fail(function () {
          $(".booking-dates").empty();
          $(".connection-error").clone().show().appendTo(".booking-dates");
          finishedLoading = true;
        });
    } else {
      finishedLoading = true;
    }

    if (SCROLL_ENABLED) {
      $window.scroll(loadOnScroll);
    }

    // close on tooltip
    $("body").on("click", ".tooltip .btn-close", function (e) {
      $(e.currentTarget).closest(".tooltip").tooltip("hide");
    });
  }

  /**
   * Get data associated with selected slot
   */
  function getSelectedTimeSlot() {
    var timeSlot = {
      location: null,
      event: null,
      data: null,
    };

    // Get slot data
    var events = allDates[state.date];
    $.each(events, function (eventIndex, event) {
      if (state.event !== null && $.inArray(state.event, event.room.eventIds) > -1 && event.venue.id == state.venue) {
        timeSlot.event = event;

        if (typeof timeSlot.event.eventPrices !== "undefined") {
          timeSlot.event = $.extend(true, {}, timeSlot.event, {
            prices: timeSlot.event.eventPrices.find(function (ep) {
              return ep.eventId === state.event;
            }),
          });
        }

        // find time slot
        $.each(event.times, function (dayIndex, day) {
          $.each(day.slots, function (slotIndex, slot) {
            if (slot.time == state.time) {
              timeSlot.data = slot;
              return false;
            }
          });

          // break $.each
          if (timeSlot.data !== null) {
            return false;
          }
        });

        // break $.each
        return false;
      }
    });

    timeSlot.location = getLocationByVenueId(state.venue);
    timeSlot.room = getRoomByEventId(state.venue, state.event);

    // return null if nothing found
    return timeSlot.event === null ? null : timeSlot;
  }

  /**
   * Get location by ID
   */
  function getLocationByVenueId(venueId) {
    var found = null;
    $.each(locations, function (locationId, location) {
      if (location.venueId === venueId) {
        found = location;
        return false;
      }
    });
    return found;
  }

  /**
   * Get room by event ID
   */
  function getRoomByEventId(venueId, eventId) {
    var found = null;
    $.each(locations, function (locationId, location) {
      $.each(location.rooms, function (roomId, room) {
        if (location.venueId === venueId && $.inArray(eventId, room.eventIds) > -1) {
          found = room;
          return false;
        }
      });
      $.each(location.tables, function (tableId, table) {
        if (location.venueId === venueId && $.inArray(eventId, table.eventIds) > -1) {
          found = table;
          return false;
        }
      });
      if (found !== null) {
        return false;
      }
    });

    return found;
  }

  /**
   * Calendar button
   */
  $(".btn-calendar")
    .datepicker({
      format: "dd/mm/yyyy",
      autoclose: true,
      maxViewMode: 0,
      orientation: "bottom left",
      startDate: today.toDate(),
    })
    .on("changeDate", function (e) {
      // update state
      state.start = moment(e.date).format("YYYYMMDD");
      state.action = "calendar";

      updateCalendar({ clear: true });
      updateUrl(PAGE_CALENDAR);
    });

  /**
   * Location button
   */
  $(".dropdown-location").on("click", "a", function (e) {
    var $a = $(e.currentTarget);

    state.venue = parseInt($a.attr("data-venue"));
    state.event = null;
    state.end = null;

    if (state.venue === 0) {
      // unselect venue
      state.venue = null;

      updateLocationFilter();
      updateCalendar({ clear: true });
      updateUrl(PAGE_CALENDAR);
      return;
    }

    updateLocationFilter();
    updateCalendar({ clear: true });
    updateUrl(PAGE_CALENDAR);
  });

  function updateLocationFilter() {
    if (state.venue === null) {
      // update dropdown box text
      $(".filter-location").text("All Locations");

      // un-hide all rooms
      $(".dropdown-room > .dropdown-menu > a, .dropdown-room > .dropdown-menu > h6").each(function (index, ele) {
        $(ele).show();
      });
    } else {
      // update dropdown box text
      $.each(locations, function (locationId, location) {
        if (location.venueId === state.venue) {
          $(".filter-location").text(location.name);
          return false;
        }
      });

      // hide rooms from other venues
      $(".dropdown-room > .dropdown-menu > a, .dropdown-room > .dropdown-menu > h6").each(function (index, ele) {
        var $ele = $(ele);
        if ($ele.attr("data-venue") != state.venue && index > 0) {
          $ele.hide();
        } else {
          $ele.show();
        }
      });
    }
  }

  /**
   * Rooms button
   */
  $(".dropdown-room").on("click", "a", function (e) {
    var $a = $(e.currentTarget);
    var eventName = $a.text();
    var venue = parseInt($a.attr("data-venue"));
    var event = parseInt($a.attr("data-event"));
    state.end = null;

    var events = $a
      .attr("data-event")
      .split(",")
      .map(function (event) {
        return parseInt(event);
      });

    // update drop down value
    if (event === 0) {
      // update state
      state.event = null;
      state.events = undefined;

      updateRoomFilter();
      updateCalendar({ clear: true });
      updateUrl(PAGE_CALENDAR);
      return;
    }

    // update state
    state.venue = venue;
    state.event = event;
    state.events = events;

    updateRoomFilter();
    updateCalendar({ clear: true });
    updateUrl(PAGE_CALENDAR);
  });

  function updateRoomFilter() {
    if (state.event) {
      $.each(locations, function (locationId, location) {
        if (location.venueId === state.venue) {
          $.each(location.rooms, function (roomId, room) {
            // match one event id or both as comma separated list
            if ($.inArray(state.event, room.eventIds) > -1) {
              $(".filter-room").html(room.name);
              return false;
            }
          });
          return false;
        }
      });
    } else {
      $(".filter-room").text("All Experiences");
    }
  }

  /**
   * Tables button
   */
  $(".dropdown-table").on("click", "a", function (e) {
    var $a = $(e.currentTarget);
    var eventName = $a.text();
    var venue = parseInt($a.attr("data-venue"));
    var event = parseInt($a.attr("data-event"));
    state.end = null;

    var events = $a
      .attr("data-event")
      .split(",")
      .map(function (event) {
        return parseInt(event);
      });

    // update drop down value
    if (event === 0) {
      // update state
      state.event = null;
      state.events = undefined;

      updateTableFilter();
      updateCalendar({ clear: true });
      updateUrl(PAGE_CALENDAR);
      return;
    }

    // update state
    state.venue = venue;
    state.event = event;
    state.events = events;

    updateTableFilter();
    updateCalendar({ clear: true });
    updateUrl(PAGE_CALENDAR);
  });

  function updateTableFilter() {
    if (state.event) {
      $.each(locations, function (locationId, location) {
        if (location.venueId === state.venue) {
          $.each(location.tables, function (tableId, table) {
            // match one event id or both as comma separated list
            if ($.inArray(state.event, table.eventIds) > -1) {
              $(".filter-table").html(table.name);
              return false;
            }
          });
          return false;
        }
      });
    } else {
      $(".filter-table").text("All Seating Areas");
    }
  }

  /**
   * Players button
   */
  $(".dropdown-player").on("click", "a", function (e) {
    var $a = $(e.currentTarget);
    var players = parseInt($a.attr("data-player"));

    // update state
    state.players = players;

    updatePlayerFilter();
    updateCalendar({ clear: true });
    updateUrl(PAGE_CALENDAR);
  });

  function updatePlayerFilter() {
    if (state.players) {
      $(".filter-player").text(state.players + " People");
    } else {
      $(".filter-player").text("2 People");
    }
  }

  /**
   * Restart search
   */
  $("body").on("click", ".link-clear-filters", function (e) {
    e.preventDefault();

    // reset filters
    $(".filter-date").text("Any Dates");
    $(".filter-room").text("All Experiences");
    $(".filter-location").text("All Locations");
    $(".btn-restart").blur();

    // update state
    state = $.extend(true, {}, DEFAULT_STATE);

    updateCalendar({ clear: true });
    updateUrl(PAGE_CALENDAR);
  });

  /**
   * Time slot button
   */
  $(".booking-dates").on("click", ".booking-slot", function (e) {
    var $time = $(e.currentTarget);
    var $event = $time.closest(".booking-event");
    var slotTime = null;

    if ($time.hasClass("unavailable")) {
      return;
    }

    // update state
    state.date = $event.attr("data-date");
    state.time = $time.attr("data-time");
    state.venue = parseInt($event.attr("data-venue"));
    state.event = parseInt($time.attr("data-event") || $event.attr("data-event"));

    // prevent booking if in past
    slotTime = moment.tz(state.date + " " + state.time, "YYYYMMDD HH:mm", VENUE_TZ);
    if (slotTime.hour() <= 4) {
      slotTime.add(1, "day");
    }
    if (slotTime.isBefore(NOW)) {
      alert("Sorry, that slot is no longer available.");
      return;
    }
    var openTableId = $time.attr("data-open-table");
    if (openTableId) {
      $(document.body).addClass("fixed");
      var openTableUrl = "https://www.opentable.com/restref/client/?restref=" + openTableId + "&datetime=" + slotTime.format("YYYY-MM-DD") + "T" + slotTime.format("HH:mm") + "&covers=2";
      var $openTable = $(document.body).append(
        '<div class="open-table"><div class="cancel"><a class="link-cancel"><img src="/images/icon-close.png" /></a></div><iframe src="' + openTableUrl + '"></iframe></div>',
      );
      $openTable.on("click", ".link-cancel", function () {
        $(document.body).removeClass("fixed");
        $(".open-table").remove();
      });
      return;
    }

    showBook();
  });

  // cancel button
  $(".booking-form").on("click", ".link-cancel", function (e) {
    // $('.form-players').val(0);
    // $('.hide-free').show();
    window.location = PAGE_CALENDAR + "?start=" + state.date;
  });

  // change players
  $(".form-players").on("change", function (e) {
    var $input = $(this);
    state.players = parseInt($input.val());
    updateUrl(PAGE_BOOK, true);

    if (state.players === "0") {
      $input.addClass("form-default");
    } else {
      $input.removeClass("form-default");
    }

    showBook({ refreshHtmlOnly: true });
  });

  /**
   * Get booking
   */
  function getBookings(opt) {
    var deferred = $.Deferred();
    var url = "/api/booking/get?start=" + opt.start + "&end=" + (opt.end || opt.start);

    if (opt.venue) {
      url += "&venue=" + opt.venue;
    }
    if (opt.order) {
      url += "&order=" + opt.order;
    }

    if (opt.useCached && Object.keys(allDates).length > 0) {
      return deferred.resolve(allDates).promise();
    }

    $.get(url)
      .done(function (response) {
        if (!response.success) {
          return deferred.reject(response.message);
        }
        // merge data
        for (var x in response.data) {
          allDates[x] = response.data[x];
        }
        if (response.header) {
          $(".booking-header").html(response.header);
        }
        deferred.resolve(response.data);
      })
      .fail(function () {
        return deferred.reject();
      });

    return deferred.promise();
  } // getBookings

  /**
   * Show calendar page
   */
  function showCalendar(opt) {
    hideAlert();
    $(".booking-form").hide();
    $(".booking-calendar").show();
    updateCalendar(opt);
  }

  /**
   * Show booking page
   */
  function showBook(opt) {
    // defaults
    opt = $.extend(true, {}, { refreshHtmlOnly: false, skipUpdateUrl: false }, opt);

    if (isLoungeHome) {
      state.action = "book";
      updateUrl(PAGE_BOOK).then(function () {
        window.location.reload();
      });
      return;
    }

    var $book = $(".booking-form");
    var $players = $book.find(".form-players");
    var players = parseInt($players.val()) || parseInt(state.players) || 0;
    var date = null;
    var slot = getSelectedTimeSlot();

    // data did not load correctly, we should restart
    if (slot === null || slot.location === null || slot.data === null || slot.event === null) {
      if (DEVELOPMENT === false && typeof Sentry !== "undefined") {
        Sentry.captureException(new Error("showBook: slot.location is null"), {
          extra: {
            state: state,
            locations: locations,
          },
        });
      }
      setTimeout(function () {
        window.location = PAGE_CALENDAR;
      }, 3000);
      return;
    }

    var roomName = slot.event.reservation.name;
    var price = (slot.event.prices.taxIncluded ? slot.event.prices.total : slot.event.prices.price) || 0;
    if (slot.room.minPlayersFixedPrice > 0 && players > slot.room.minPlayersFixedPrice) {
      price = round10((price * slot.room.minPlayersFixedPrice) / players);
    }
    var amount = round10(players * price);

    var bookNotes = [];

    var minimumNumber = slot.event.reservation.slot.minGroupSize;
    var privateRoomSize = slot.event.reservation.slot.maxGroupSize > 6 ? 2 : 1;
    var privateRoomPlayers = slot.room.privateRoomPlayers ? slot.room.privateRoomPlayers : slot.event.reservation.slot.maxGroupSize - privateRoomSize;

    // no longer available
    if (slot.data.free < minimumNumber) {
      state = $.extend(true, {}, DEFAULT_STATE);
      updateUrl(PAGE_CALENDAR);
      showCalendar();
      return;
    }

    // reset alert
    hideAlert();

    if (opt.refreshHtmlOnly === false) {
      window.scrollTo(0, 0);
    }

    if (price === 0) {
      $(".hide-free").hide();
    } else {
      $(".hide-free").show();
    }

    // update cart item
    $book.find(".book-image").css({ "background-image": "url('images/rooms/" + slot.event.room.key + ".jpg')" });
    $book.find(".book-image img").attr("src", "/images/rooms/banner-" + slot.event.room.key + ".png");

    var room = getRoomByEventId(slot.event.venue.id, slot.event.reservation.id);
    $book.find(".book-info").html(room.shortText);

    $book.find(".book-price").html(formatPrice(price));

    $book.find(".book-room-name").text(roomName);
    $book.find(".book-date-long").text(formatDateAsLong(state.date));
    if (room.time && Number.isInteger(room.time)) {
      $book.find(".book-time").text(formatTime(state.time) + "(" + room.time + "min)");
    } else if (room.time) {
      $book.find(".book-time").text(formatTime(state.time) + "(" + room.time + ")");
    } else {
      $book.find(".book-time").text(formatTime(state.time));
    }
    $book.find(".book-amount").text(formatPrice(amount));

    $book.find(".book-business-name").text(slot.location.businessName);
    $book.find(".book-address").text([slot.location.address.streetAddress, slot.location.address.addressLocality, slot.location.address.addressRegion].join(", "));
    $book
      .find(".book-address-html")
      .html(slot.location.address.streetAddress + "<br/>" + slot.location.address.addressLocality + ", " + slot.location.address.addressRegion + " " + slot.location.address.postalCode);
    $book.find(".book-phone").text(slot.location.address.telephone);
    $book.find(".book-map").css({ backgroundImage: "url(/images/" + slot.location.mapImage + ")" });

    // add book notes if required
    if (slot.room.bookNote) {
      bookNotes.push(slot.room.bookNote);
    }

    if (opt.refreshHtmlOnly === false) {
      if (typeof fbq !== "undefined") {
        fbq("track", "InitiateCheckout");
      }
      if (typeof ttq !== "undefined") {
        ttq.track("InitiateCheckout");
      }

      $players.empty();
      $players.addClass("form-default");
      $players.append($("<option/>", { text: "Number of " + slot.room.playerLabel, value: 0 }));

      var maximumNumber = slot.data.free < slot.event.reservation.slot.maxGroupSize ? slot.data.free : slot.event.reservation.slot.maxGroupSize;
      var minPlayersFixedPrice = room.minPlayersFixedPrice || 0;
      $(".text-player-label").text(slot.room.playerLabel);
      for (var x = minimumNumber; x <= maximumNumber; x++) {
        var selectFirst = x == minimumNumber && slot.room.playerSelectFirst;
        if (selectFirst) {
          state.players = x;
        }
        var value = x === 1 ? slot.room.playerValue : slot.room.playerValuePlural;
        var text = x + " " + value;
        if (x >= privateRoomPlayers && slot.data.orders === 0 && slot.room.private !== false && privateRoomPlayers !== 1) {
          text = x + " " + value + " (Private)";
        }
        if (x > minPlayersFixedPrice && minPlayersFixedPrice > 0) {
          text = x + " " + value + " (No extra cost)";
        }
        var $option = $("<option/>", { value: x, text: text, selected: String(x) === state.players || selectFirst });
        $players.append($option);
      }

      if (state.players) {
        $players.val(state.players);
      }
      if ($players.val() !== "0") {
        $players.removeClass("form-default");
      }

      var $custom = $(".custom-row");
      $custom.empty();

      let customFields = slot.event.reservation.custom;
      if (customFields.length > 0) {
        var $customRow = $([]);
        customFields.forEach(function (custom) {
          if (
            custom.values === null ||
            ["discount", "promo", "virtual experience"].indexOf(custom.name.toLowerCase()) > -1 ||
            custom.name.toLowerCase().indexOf("promo") > -1 ||
            custom.name.toLowerCase().indexOf("hide") > -1
          ) {
            return;
          }
          var values = custom.values.map(function (value) {
            return "<option>" + value + "</option>";
          });
          values.unshift('<option value="">Select ' + custom.name + "</option>");

          var $select = $('<select name="custom-' + custom.id + '" class="custom-select form-custom form-default form-custom-' + custom.id + '">' + values + "</select>");
          var $name = $("<strong>" + custom.name + "</strong>");
          var $moreInfo = null;
          if (custom.name === "Difficulty") {
            $moreInfo = addToolTip(
              $('<span class="more-info text-sm"><i class="fa fa-info-circle"></i> More Info</span>'),
              "Amp up the challenge: Experienced players & big groups should opt for hard mode.",
            );
          }
          $customRow = $customRow.add($('<div class="col-12 col-md-6"></div').append($name, $moreInfo));
          $customRow = $customRow.add($('<div class="col-12 col-md-6 text-md-right"></div>').append($select));
          console.log($customRow);
        });
        $custom.append($("<div/>", { class: "row" }).append($customRow)).show();
        $custom.on("change", "select", function () {
          $(this).removeClass("form-default");
        });
      } else {
        $custom.hide();
      }

      $(".booking-calendar").hide();
      $(".booking-form").show();

      state.action = "book";
      if (opt.skipUpdateUrl === false) {
        updateUrl(PAGE_BOOK);
      }

      if (bookNotes.length > 0) {
        var bookNoteHtml = bookNotes.join("<hr/>");
        if (slot.room.acceptBookNote) {
          bookNoteHtml =
            '<div class="form-check"><input type="checkbox" class="form-check-input" id="acceptBookNote"/><label class="form-check-label" for="acceptBookNote"><strong>I acknowledge that I have read and accept the following:</strong> <span class="text-normal">' +
            bookNoteHtml +
            "</span></label></div>";
        }
        $(".info-row").show().find(".alert-message").html(bookNoteHtml);
      } else {
        $(".info-row").hide();
      }
    }
  } // showBook

  /**
   * Complete booking
   */
  $(".booking-form .button-complete").on("click", function (e) {
    e.preventDefault();
    hideAlert();

    if (bookingProcessing) {
      return;
    }

    var previousCompleteText = $(this).text();
    var $button = $(this).html('<span class="position-relative d-inline-block">Processing<span>');
    var spinner = new Spinner($.extend(true, {}, DEFAULT_SPIN_OPTS, { color: "#000", scale: 0.2, top: "11px", left: "-20px" })).spin($button.find("span")[0]);
    bookingProcessing = 1;

    function stopSpinning() {
      spinner.stop();
      $button.html(previousCompleteText);
    }

    var slot = getSelectedTimeSlot();

    // cart data
    var data = {
      icon: "/images/rooms/" + slot.room.key + ".jpg",
      venueId: slot.location.venueId,
      eventId: parseInt(state.event),
      name: slot.room.name,
      date: parseInt(state.date),
      time: state.time,
      persons: state.players || 0,
      price: slot.event.reservation.prices.price,
      isLounge: isLounge,
      custom: [],
    };

    // player should be selected
    if (data.persons === 0) {
      showAlert("Please choose the number of " + slot.room.playerLabel + " before booking.");
      stopSpinning();
      bookingProcessing = 0;
      return;
    }

    // custom validation
    if (slot.event.reservation.custom.length > 0) {
      for (var x = 0; x < slot.event.reservation.custom.length; x++) {
        var custom = slot.event.reservation.custom[x];
        if ($(".form-custom-" + custom.id).val() === "") {
          showAlert(custom.name + " must be selected.");
          stopSpinning();
          bookingProcessing = 0;
          return;
        }
      }
    }

    // accept
    if (slot.room.acceptBookNote && $("#acceptBookNote:checked").length === 0) {
      showAlert("Please acknowledge that you have read the booking notice.");
      stopSpinning();
      bookingProcessing = 0;
      return;
    }

    // add custom data
    if (slot.event.reservation.custom.length > 0) {
      slot.event.reservation.custom.forEach(function (custom) {
        var $custom = $(".form-custom-" + custom.id);
        if ($custom.length === 1) {
          data.custom.push({
            id: custom.id,
            name: custom.name,
            value: $custom.val(),
          });
        }
      });
    }

    var url = "/" + site + "/cart/add";
    if (KIOSK_MODE) {
      url = kioskPath + "/cart/add";
    }

    $.ajax({
      method: "post",
      url: url,
      data: JSON.stringify(data),
      cache: false,
      dataType: "json",
      contentType: "	application/json",
      success: function (response) {
        if (response.success === 0) {
          bookingProcessing = 0;
          showAlert(response.message);
          stopSpinning();
          return;
        }

        stopSpinning();
        bookingProcessing = 0;

        if (KIOSK_MODE) {
          return (window.location = kioskPath + "/cart");
        }
        window.location = "/" + site + "/cart";
      },
      error: function (xhr, status) {
        showAlert("There was a connection error. Please try again.");
        bookingProcessing = 0;
        stopSpinning();
      },
    });
  }); // completeBooking

  /**
   * Format price
   */
  function formatPrice(price, decimals) {
    if (typeof decimals === "undefined") {
      decimals = 2;
    }
    var negative = price < 0 ? "-" : "";
    return (
      negative +
      "$" +
      Math.abs(price)
        .toFixed(decimals)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    );
  }

  /**
   * Add spinner to calendar view
   */
  function addSpinner(opt) {
    // don't spin again
    if (_spinner !== null) {
      if ($("body")[0].contains(_spinner.el) === true) {
        return;
      } else {
        _spinner = null;
      }
    }

    var $dates = $(".booking-dates");
    opt = $.extend(true, {}, { clear: true }, opt);
    if (opt.clear) {
      isAutoScroll = 0;
      $dates.empty();
    }
    $dates.append($loadingCopy.clone());

    var spin_opts = $.extend(true, {}, DEFAULT_SPIN_OPTS);

    // add spinner to loading div
    _spinner = new Spinner(spin_opts).spin($(".booking-loading span")[0]);
  }

  /**
   * Remove spinner
   */
  function stopSpinner() {
    if (_spinner !== null) {
      _spinner.stop();
      _spinner = null;
    }
  }

  // convert hash into state object
  function stateFromQuery() {
    var query = document.location.search;
    var values = {};
    var pairs = null;

    if (query != "") {
      query = query.substring(1);
      pairs = query.split("&");
      for (var x = 0; x < pairs.length; x++) {
        var d = pairs[x].split("=");
        if (d[0] === "time") {
          d[1] = moment(d[1], "HHmm").format("HH:mm");
        }
        values[d[0]] = decodeURIComponent(d[1]);
        if ($.inArray(d[0], ["event", "venue", "players", "order"]) > -1) {
          values[d[0]] = parseInt(values[d[0]]);
        }
        if (d[0] === "events") {
          values[d[0]] = values[d[0]].split(",").map(function (id) {
            return parseInt(id);
          });
        }
      }
    }
    // determine action based on url
    if (document.location.pathname.indexOf("/booking-book") > -1) {
      state.action = "book";
    } else if (document.location.pathname.indexOf("/booking-complete") > -1) {
      state.action = "complete";
    } else {
      state.action = "calendar";
    }
    return values;
  }

  // convert state opject into hash
  function queryFromState(state) {
    var queryItems = [];
    for (var key in state) {
      var value = state[key];
      // we can infer action from the URL, bsource to be dropped
      if (key === "action" || key === "bsource" || key === "useCache") {
        continue;
      }
      if (key === "time" && value !== null) {
        value = value.replace(":", "");
      }
      // don't add default items (or end cause it's useless)
      if (DEFAULT_STATE[key] !== value && key !== "end" && value !== null) {
        queryItems.push(key + "=" + encodeURIComponent(value));
      }
    }
    if (queryItems.length > 0) {
      return "?" + queryItems.join("&");
    }
    return "";
  }

  // return long date format from YYYYMMDD
  function formatDateAsLong(date) {
    var d = moment(date, "YYYYMMDD");
    var mask = site === "brisbane" ? "dddd, Do MMMM" : "dddd MMMM Do";
    if (d.year() !== today.year()) {
      mask += site === "brisbane" ? " YYYY" : ", YYYY";
    }
    return d.format(mask);
  }

  // return short date format from YYYYMMDD
  function formatDate(date) {
    var d = moment(date, "YYYYMMDD");
    var mask = site === "brisbane" ? "Do MMMM" : "MMMM Do";
    if (d.year() !== today.year()) {
      mask += site === "brisbane" ? " YYYY" : ", YYYY";
    }
    return d.format(mask);
  }

  // return AM/PM format from military
  function formatTime(time) {
    var timezone = "";
    return moment(time, "HH:mm").format("h:mm A") + timezone;
  }

  // round values to 2 decimals
  function round10(num) {
    return +(Math.round(num + "e+" + 2) + "e-" + 2);
  }

  /**
   * Update available bookings in calendar
   */
  function updateCalendar(opt) {
    // default options
    opt = $.extend(true, { clear: false, next: null, force: false, updateDate: true }, opt);

    if (isLoading && opt.force === false) {
      return lastUpdateCalendarPromise.promise();
    }

    isLoading = true;
    var updateCalendarPromise = $.Deferred();
    lastUpdateCalendarPromise = updateCalendarPromise;

    if (opt.clear) {
      isAutoScroll = 0;
      $bookings.empty();
    }

    addSpinner(opt);

    if (opt.useCache) {
      state.useCache = true;
    }

    if (opt.next !== null) {
      if (!lastDateFetched) {
        lastDateFetched = moment.tz(state.start, "YYYYMMDD", VENUE_TZ).add(DATES_PER_FETCH, "days");
      } else {
        lastDateFetched.add(1, "days");
      }
      state.start = lastDateFetched.format("YYYYMMDD");

      lastDateFetched.add(opt.next, "days");
      state.end = lastDateFetched.format("YYYYMMDD");
    } else {
      // set end date
      lastDateFetched = moment.tz(state.start, "YYYYMMDD", VENUE_TZ).add(DATES_PER_FETCH, "days");
      state.end = lastDateFetched.format("YYYYMMDD");
    }

    // hide / show clear filter
    if (state.venue !== null || state.event !== null || state.date !== START_SEARCH_DATE.format("YYYYMMDD")) {
      $(".booking-calendar").addClass("has-filters");
    } else {
      $(".booking-calendar").removeClass("has-filters");
    }

    // update filters
    if (opt.updateDate) {
      var currentDate = moment(state.start || START_SEARCH_DATE, "YYYYMMDD");
      $(".filter-date").text(currentDate.format("MMMM D, YYYY"));
      $(".btn-calendar").datepicker("update", currentDate.toDate());
    }
    updateLocationFilter();
    updateRoomFilter();
    updateTableFilter();
    updatePlayerFilter();

    getBookings(state)
      .done(function (dates) {
        // remove spinner
        $bookings.find(".booking-loading").remove();

        var startDate = moment(state.start);
        var endDate = moment(state.end);
        var dateKeys = [];
        while (startDate.isSameOrBefore(endDate, "day")) {
          dateKeys.push(startDate.format("YYYYMMDD"));
          startDate.add(1, "days");
        }
        if (isLocationEvent) {
          dateKeys = Object.keys(dates);
        }

        var freeSlots = 0;
        var bookingsCount = 0;
        $.each(dateKeys, function (index, date) {
          var events = dates[date] || [];
          var $booking = $bookingCopy.clone();
          var $events = $booking.find(".booking-events");
          var $venue = $booking.find(".booking-venue");
          var $venueClone = $venue.clone();
          var slotDate = moment(date, "YYYYMMDD");
          var lastVenue = -1;
          var eventSlots = 0;
          var dayFreeSlots = 0;

          // set date
          $booking.find(".booking-date").find("span").text(formatDateAsLong(date));

          // show closed if no events
          if (events.length === 0) {
            $booking.find(".booking-date-container").addClass("sold-out");
            $booking.find(".sold-out-message").text("Closed");
            if (!isLoungeHome && !isCamp) {
              $bookings.append($booking);
            }
            return;
          }

          if (index === 1 && $bookings.children().length === 1 && !isLocationEvent) {
            $bookings.append('<div class="more-dates"><hr/><h3>More Dates</h3></div>');
          }

          // add events
          $.each(events, function (eventIndex, event) {
            var $event = $eventCopy.clone();
            var $slots = $event.find(".booking-slots");
            var room = getRoomByEventId(event.venue.id, event.reservation.id);

            $event.attr("data-date", date);
            $event.attr("data-venue", event.venue.id);
            $event.attr("data-event", event.reservation.id);

            if (lastVenue != event.venue.id) {
              $venue.find("span").eq(0).html(event.venue.name);
              if (event.venue.notes) {
                $venue.find("small").eq(0).html(event.venue.notes);
              }
              if (lastVenue != -1) {
                $events.append('<hr class="mt-0"/>');
                $events.append($venue);
              }
              $venue = $venueClone.clone();
              lastVenue = event.venue.id;
            }

            $slots.empty();
            $event.find(".booking-name").html(event.reservation.name + event.reservation.icons);

            // Booking info and more info
            var $bookingInfo = $event.find(".booking-info");
            if (event.room.info) {
              $bookingInfo.show().find(".booking-info-text").html(event.room.info);
            }
            if (room && room.moreInfo) {
            	$bookingInfo.find('.more-info').hide().tooltip({
            		delay: {
            			show : 300,
            			hide : 300
            		},
            		html     : true,
            		trigger  : 'click',
            		template : '<div class="tooltip" role="tooltip"><div class="arrow"></div><i class="fa fa-close btn-close btn-close-top"></i><div class="tooltip-scroll"><div class="tooltip-inner"></div></div><div class="btn-close btn-close-bottom">Close</div></div>',
            		title    : room.moreInfo
            	}).on('show.bs.tooltip', function(e) {
            		// create a backdrop that hides the tooltip on click
            		var $backdrop = $('<div class="tooltip-backdrop"></div>');
            		$backdrop.data('target', e.currentTarget);
            		$('body').append($backdrop);
            		$backdrop.on('click', function(e) {
            			var $target = $($(this).data().target);
            			$target.tooltip('hide');
            		});
            	}).on('hidden.bs.tooltip', function(e) {
            		$('.tooltip-backdrop').remove();
            	});
            }
            else {
            	$bookingInfo.find('.more-info').hide();
            }
            $event.find(".booking-date > span").text(slotDate.format("MMMM D, YYYY"));

            var hide = false;
            // venue selected, hide other venues
            if (state.venue !== null && state.venue !== event.venue.id) {
              hide = true;
            }

            // event selected, hide other events
            if (typeof state.events !== "undefined") {
              var found = false;
              state.events.forEach(function (eventId) {
                if ($.inArray(eventId, event.room.eventIds) > -1) {
                  found = true;
                }
              });
              hide = found === false;
            } else if (state.event !== null && $.inArray(state.event, event.room.eventIds) === -1) {
              hide = true;
            }

            if (hide) {
              $event.hide();
            } else {
              var room = getRoomByEventId(event.venue.id, event.reservation.id);
              if (room === null) {
                if (typeof Sentry !== "undefined") {
                  Sentry.captureException(new Error("getBookings: room is null"), {
                    extra: {
                      state: state,
                      event: event,
                    },
                  });
                }
                return;
              }
              if (room.openTableId) {
                var $slot = $slotCopy.clone();
                var slotTime = moment.tz(date + " " + NOW.format("HH:mm"), "YYYYMMDD HH:mm", VENUE_TZ);
                $slot.attr("data-event", event.reservation.id);
                $slot.attr("data-open-table", room.openTableId);
                $slot.find(".booking-time").text("Find a Table");
                if (slotTime.isSame(NOW, "day")) {
                  $slot.attr("data-time", slotTime.add(75, "minutes").startOf("hour").format("HH:mm"));
                } else {
                  $slot.attr("data-time", "17:00");
                }
                $slot.addClass("slot-open-table");
                $slots.append($slot);
                $events.append($event);
                return;
              }
              var eventSlotCount = 0;
              $.each(event.times, function (timeIndex, time) {
                $.each(time.slots, function (slotIndex, slot) {
                  var dayOfWeek = moment(date, "YYYYMMDD").day();
                  var $slot = $slotCopy.clone();
                  var timeAsInt = parseInt(slot.time.replace(":", ""));

                  // add event id to slot if required
                  if (slot.eventId) {
                    $slot.attr("data-event", slot.eventId);
                  }

                  // hide slot if it past
                  var slotTime = moment.tz(date + " " + slot.time, "YYYYMMDD HH:mm", VENUE_TZ);
                  if (parseInt(slot.time.replace(":", "")) < 600) {
                    slotTime.add(1, "day");
                  }
                  if (slotTime.isBefore(NOW)) {
                    slot.free = 0;
                  }

                  var minimumPlayers = event.reservation.slot.minGroupSize;
                  var privateRoomSize = event.reservation.slot.maxGroupSize > 6 ? 2 : 1;
                  var privateRoomPlayers = room.privateRoomPlayers ? room.privateRoomPlayers : event.reservation.slot.maxGroupSize - privateRoomSize;

                  // Hide slots if room is private
                  if (slot.free <= event.reservation.slot.maxGroupSize - privateRoomPlayers) {
                    $slot.addClass("unavailable");
                  } else if (slot.free < minimumPlayers) {
                    $slot.addClass("unavailable");
                  } else {
                    $slot.removeClass("unavailable");
                    $slot.attr("data-time", slot.time);
                    dayFreeSlots += 1;
                    freeSlots += 1;
                  }

                  if ($slot.hasClass("unavailable") && slotTime.hour() < 17 && [460, 480, 493].includes(event.venue.id) && [0, 6].includes(slotTime.day()) && date >= 20241125 && date <= 20241220) {
                    $slot.hide();
                  }

                  if (slot.eventId) {
                    var slotPrice = event.eventPrices.find(function (ep) {
                      return ep.eventId === slot.eventId;
                    });
                    var price = (slotPrice.taxIncluded ? slotPrice.total : slotPrice.price) || 0;
                    if (slotPrice.discounted) {
                      $slot.addClass("discounted");
                    }
                    if (slotPrice.price) {
                      $slot.find(".booking-free").text("$" + price);
                    } else {
                      $slot.find(".booking-free").text(slot.free);
                      $slot.find(".fa-user").removeClass("fa-user").addClass("fa-users");
                      // $slot.find('.fa-user').remove();
                    }
                  } else if (event.prices.price) {
                    var price = (event.prices.taxIncluded ? event.prices.total : event.prices.price) || 0;
                    $slot.find(".booking-free").text("$" + price);
                  } else {
                    $slot.find(".fa-user").css({ opacity: 0 });
                  }
                  if (EVENT_NAME === "oktoberfest") {
                    $slot.find(".booking-time").text("PURCHASE");
                  } else {
                    $slot.find(".booking-time").text(formatTime(slot.time));
                  }
                  if (room && room.hidePlayers === true) {
                    $slot.find(".fa-user").remove();
                  }

                  $slots.append($slot);
                  eventSlots++;
                  eventSlotCount++;
                });
              });
              if (eventSlotCount) {
                $events.append($event);
              }
            }
          });

          if (eventSlots > 0 && dayFreeSlots === 0) {
            $booking.find(".booking-date-container").addClass("sold-out");
            if (site === "regina") {
              $booking
                .find(".sold-out-message")
                .replaceWith(
                  '<div class=""><p class="mt-4 text-primary">Limited availability</p><p class="text-sm text-primary-alt">Please email <a href="mailto:gatekeeper@escapemanor.com">gatekeeper@escapemanor.com</a> to make a reservation.</p></div>',
                );
            }
            if (isLoungeHome) {
              return;
            }
          }
          if (isLoungeHome && bookingsCount > 0) {
            return;
          }
          $bookings.append($booking);
          bookingsCount += 1;
        });

        if (SCROLL_ENABLED && ((lastDateFetched.isBefore(SIX_MONTHS) && freeSlots === 0) || (lastDateFetched.isBefore(SIX_MONTHS) && isWindowFull() === false))) {
          return updateCalendar({ next: isLoungeHome ? DATES_PER_FETCH : 14, clear: false, force: true, updateDate: false }).then(function () {
            updateCalendarPromise.resolve();
          });
        } else {
          // we are passed our 6 months, display a sorry message if no dates were found
          if ($(".booking-dates > div").length === 0) {
            $(".booking-dates").empty();
            $(".noslots-error").clone().show().appendTo(".booking-dates");
          }
          isLoading = false;
          return updateCalendarPromise.resolve();
        }
      })
      .fail(function () {
        $(".booking-dates").empty();
        $(".connection-error").clone().show().appendTo(".booking-dates");
        isLoading = false;
        return updateCalendarPromise.reject();
      });

    return updateCalendarPromise.promise();
  }

  /**
   * Return true if the window is filled entirely with the booking calendar.
   */
  function isWindowFull() {
    if (window.innerHeight >= $document.height() - footerHeight) {
      return false;
    }
    return true;
  }

  /**
   * Verify on scroll if we should load more timeslots.
   */
  function loadOnScroll() {
    if (window.scrollY + window.innerHeight >= $document.height() - footerHeight) {
      // avoid multiple hits while this loads
      if (isLoading || isAutoScroll) {
        isAutoScroll++;
        return;
      }

      if (!isLoading && allDates && $(".booking-calendar").is(":visible")) {
        if (lastDateFetched && lastDateFetched.isAfter(SIX_MONTHS)) {
          stopSpinner();
          return;
        }
        isAutoScroll++;

        if (DEVELOPMENT) {
          console.log("Auto load:: loading");
        }

        if (state.event !== null) {
          updateCalendar({ next: 14, clear: false, updateDate: false }).then(function () {
            isAutoScroll--;
            if (isAutoScroll) {
              isAutoScroll = 0;
              loadOnScroll();
            }
          });
        } else {
          updateCalendar({ next: DATES_PER_FETCH, clear: false, updateDate: false }).then(function () {
            isAutoScroll--;
            if (isAutoScroll) {
              isAutoScroll = 0;
              loadOnScroll();
            }
          });
        }
      }
    }
  }

  /**
   * Show alert
   */
  function showAlert(message) {
    $(".alert-row").show().find(".alert-message").text(message);
  }

  function hideAlert() {
    $(".alert-row").attr({ style: "display: none!important" });
  }

  /**
   * Add tooltip
   */
  function addToolTip(element, content) {
    element
      .tooltip({
        delay: {
          show: 150,
          hide: 150,
        },
        html: true,
        trigger: "click",
        template:
          '<div class="tooltip" role="tooltip"><div class="arrow"></div><i class="fa fa-close btn-close btn-close-top"></i><div class="tooltip-scroll"><div class="tooltip-inner"></div></div><div class="btn-close btn-close-bottom">Close</div></div>',
        title: content,
      })
      .on("show.bs.tooltip", function (e) {
        // create a backdrop that hides the tooltip on click
        var $backdrop = $('<div class="tooltip-backdrop"></div>');
        $backdrop.data("target", e.currentTarget);
        $("body").append($backdrop);
        $backdrop.on("click", function (e) {
          var $target = $($(this).data().target);
          $target.tooltip("hide");
        });
      })
      .on("hidden.bs.tooltip", function (e) {
        $(".tooltip-backdrop").remove();
      });
    return element;
  }

  onFinishedLoading();
});
